import React from 'react'
import { formatDateTimeWithAt } from './FormatDateTimeWithAt'
import SignImagePreview from './SignImagePreview'

const SignData = ({data}) => {
    let signatureDateTimeFormatted = formatDateTimeWithAt(data?.ProviderSignatureDate)
    console.log("SignData", data)
  return (<div className="d-flex ">
            <div className="ar-sign-new-design d-flex flex-column gap-1">
                <div className="">
                    <SignImagePreview BucketPath={data?.SignaturePath} />
                </div>
                <p className="heading text-black">Electronically Co-Signed By/Date:</p>
                <p className='heading green-text'>{data?.ProviderSignBy || 'N/A'} on {signatureDateTimeFormatted || 'N/A'}</p>
            </div>
        </div>
  )
}

export default SignData